import { FormControl, FormGroup } from '@angular/forms';
import type { Form } from '../interfaces/form.interface';
import { InputType } from '../interfaces/input.interface';

export class RepeatableBindingsUtils {
    public static index<T>(form: Form<T>): Set<string> {
        const bindingControlNames = new Set<string>();

        for (const section of form.sections) {
            if (!section.isVisible) {
                continue;
            }

            for (const field of section.fields) {
                if (!field.conditions.isVisible || field.conditions.isRetained) {
                    continue;
                }

                if (field.input?.type !== InputType.REPEATABLE_GROUP) {
                    continue;
                }

                const bindings = field.input?.repeatableGroupConfiguration?.bindings ?? {};

                for (const controlName of Object.values(bindings)) {
                    if (controlName) {
                        bindingControlNames.add(String(controlName));
                    }
                }
            }
        }

        return bindingControlNames;
    }

    public static patchFromPreviousDataPristine<T>(form: Form<T>, model: FormGroup, previousData: T | null): void {
        const previousRecord = previousData as Record<string, unknown> | null;

        if (!previousRecord) {
            return;
        }

        for (const section of form.sections) {
            if (!section.isVisible) {
                continue;
            }

            for (const field of section.fields) {
                if (!field.conditions.isVisible || field.conditions.isRetained) {
                    continue;
                }

                if (field.input?.type !== InputType.REPEATABLE_GROUP) {
                    continue;
                }

                const bindings = field.input?.repeatableGroupConfiguration?.bindings ?? {};

                for (const [logicalKey, targetControlName] of Object.entries(bindings)) {
                    const controlName = String(targetControlName ?? '');

                    if (!controlName) {
                        continue;
                    }

                    const control = model.get(controlName) as FormControl | null;

                    if (!control || !control.pristine) {
                        continue;
                    }

                    const rawValue = previousRecord[controlName] ?? previousRecord[logicalKey];
                    const nextValue = rawValue === null || rawValue === undefined ? '' : String(rawValue);
                    const currentValue = String(control.value ?? '');
                    const shouldForceRehydrate = currentValue === nextValue && nextValue.trim() !== '';

                    if (!shouldForceRehydrate && currentValue === nextValue) {
                        continue;
                    }

                    control.patchValue(nextValue, { emitEvent: true });
                }
            }
        }
    }
}
